import { FC } from 'react';

import { Dropdown } from 'antd';
import cs from 'classnames';

import { SelectCardWrapperPermissionsDetails } from 'types/commons';

import { SidebarContentTypes } from 'constants/enums';

import { ReactComponent as MoreIcon } from 'assets/icons/more.svg';

import styles from './SelectCardWrapper.module.scss';
import { useCardActions } from './hooks/useCardActions';

interface CardActionsMenuProps {
  sidebarContentType: SidebarContentTypes;
  permissions: SelectCardWrapperPermissionsDetails[] | undefined;
  contentId: string | undefined;
  tourId?: string;
}

const CardActionsMenu: FC<CardActionsMenuProps> = ({
  sidebarContentType,
  permissions,
  contentId,
  tourId
}) => {
  const { actions, isPermitted, activeComponent } = useCardActions(
    sidebarContentType,
    permissions,
    contentId
  );

  return (
    <div className={styles.actions}>
      <Dropdown
        menu={{ items: actions }}
        trigger={['click']}
        className={styles.dropdown}
        rootClassName={styles.dropdownRoot}
        disabled={!isPermitted}
      >
        <div
          className={cs(styles.moreIcon, { [styles.disabled]: !isPermitted })}
        >
          <MoreIcon id={tourId} />
        </div>
      </Dropdown>
      {activeComponent}
    </div>
  );
};

export default CardActionsMenu;
